import { render, staticRenderFns } from "./trainingMaterials.vue?vue&type=template&id=5a0a5fce&scoped=true"
import script from "./trainingMaterials.vue?vue&type=script&lang=js"
export * from "./trainingMaterials.vue?vue&type=script&lang=js"
import style0 from "./trainingMaterials.vue?vue&type=style&index=0&id=5a0a5fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a5fce",
  null
  
)

export default component.exports